import { CarFleetViewRecord } from '@navio/nsdk';
import { NoddiBadge } from 'noddi-ui-web';
import { BadgeColumnContainer } from './BadgeColumnContainer';
import { BookingInFleetTable } from './BookingInFleetTable';

// Per-car booking slice as exposed by list endpoints (fleet view,
// storage inventory). Derived from CarFleetViewRecord so this stays
// in sync with the backend BookingForCarRecord shape without naming
// it directly — the nsdk type name has churned.
type BookingForCar = NonNullable<CarFleetViewRecord['latestCompletedBooking']>;

type Props = {
  booking: BookingForCar | null | undefined;
  cancelledLabel?: string;
  noneLabel?: string;
};

export const LatestCompletedBookingCell = ({ booking, cancelledLabel = 'Cancelled', noneLabel = 'None' }: Props) => {
  if (!booking) {
    return (
      <BadgeColumnContainer>
        <NoddiBadge variant='outline'>{noneLabel}</NoddiBadge>
      </BadgeColumnContainer>
    );
  }
  return (
    <BookingInFleetTable
      // completedAt should always be set for completed bookings; fall back to booking date defensively.
      date={booking.completedAt ?? booking.date}
      variant='completed'
      salesItems={booking.salesItems}
      cancelledAt={booking.cancelledAt}
      cancelledLabel={cancelledLabel}
    />
  );
};
